import type { PathType } from './types';
import { getPath } from './types';

export const hrTicketPaths: { [key: string]: PathType } = {
  // Biometric related
  // biometricLog: getPath('/interactive/system-admin/biometric-log', [
  //   'sidebar.hr.biometric.index',
  //   'sidebar.hr.biometricLog'
  // ]),
  biometricEmployeeMapping: getPath('/interactive/system-admin/biometric-employee-mapping', [
    'sidebar.hr.biometric.index',
    'sidebar.hr.biometricEmployeeMapping'
  ]),
  biometricDevice: getPath('/interactive/system-admin/biometric-device', [
    'sidebar.hr.biometric.index',
    'sidebar.master-data.biometricDevice'
  ]),
  biometricLog: getPath('/biometric-log', ['v2.sidebar.home', 'v2.sidebar.hrTicket.biometricLog']),
  biometricLogSub: getPath('/s/biometric-log', ['v2.sidebar.home', 'v2.sidebar.hrTicket.biometricLog']),

  // HR general
  advancePaymentLimit: getPath('/interactive/system-admin/advance-payment-limit', [
    'v2.sidebar.home',
    'sidebar.hr.index',
    'sidebar.hr.advancePaymentLimit'
  ]),
  employeeEvaluation: getPath('/interactive/system-admin/employee-evaluation', [
    'v2.sidebar.home',
    'sidebar.hr.index',
    'sidebar.hr.employeeEvaluation'
  ]),
  leaveRemainingYear: getPath('/interactive/system-admin/leave-remaining-year', [
    'sidebar.home',
    'v2.leaveRemainingYear.index'
  ]),
  employeeShift: getPath('/interactive/system-admin/employee-shift', ['sidebar.home', 'v2.employeeShift.index']),
  advancePaymentEmployee: getPath('/interactive/system-admin/advance-payment-employee', [
    'sidebar.home',
    'v2.advancePaymentEmployee.index'
  ]),

  additionalWage: getPath('/interactive/system-admin/additional-wage', ['sidebar.home', 'v2.additionalWage.index']),
  employeeCompensation: getPath('/interactive/system-admin/employee-compensation', [
    'sidebar.home',
    'v2.employeeCompensation.index'
  ]),
  timesheet: getPath('/interactive/system-admin/timesheet', ['sidebar.home', 'sidebar.hr.timesheet']),
  timesheetAdd: getPath('/interactive/system-admin/timesheet/add', [
    'sidebar.home',
    'v2.timesheet.index',
    'action.add'
  ]),
  timesheetDetail: getPath('/interactive/system-admin/timesheet/detail', [
    'sidebar.home',
    'v2.timesheet.index',
    'page.detail'
  ]),

  // V2 HR Ticket paths
  hrTicket: getPath('/ticket-raising/hr-ticket', ['v2.sidebar.home', 'v2.helpdesk.index', 'sidebar.hr.index']),

  // Advance Payment Ticket
  advancePaymentTicket: getPath('/ticket-raising/hr-ticket/advance-payment-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.advancePaymentTicket'
  ]),
  myAdvancePaymentTicket: getPath('/ticket-raising/hr-ticket/advance-payment-ticket/my-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.advancePaymentTicket',
    'Phiếu của tôi'
  ]),
  advancePaymentTicketApproval: getPath('/ticket-raising/hr-ticket/advance-payment-ticket/approval', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.advancePaymentTicket',
    'v2.sidebar.approval'
  ]),
  advancePaymentTicketAdd: getPath('/ticket-raising/hr-ticket/advance-payment-ticket/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.advancePaymentTicket',
    'action.add'
  ]),
  advancePaymentTicketEdit: getPath('/ticket-raising/hr-ticket/advance-payment-ticket/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.advancePaymentTicket',
    'action.edit'
  ]),
  advancePaymentTicketDetail: getPath('/ticket-raising/hr-ticket/advance-payment-ticket/detail', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.advancePaymentTicket',
    'page.detail'
  ]),

  // Leave Ticket
  leaveTicket: getPath('/ticket-raising/hr-ticket/leave-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.leaveTicket'
  ]),
  myLeaveTicket: getPath('/ticket-raising/hr-ticket/leave-ticket/my-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.leaveTicket',
    'Phiếu của tôi'
  ]),
  leaveTicketApproval: getPath('/ticket-raising/hr-ticket/leave-ticket/approval', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.leaveTicket',
    'v2.sidebar.approval'
  ]),
  leaveTicketAdd: getPath('/ticket-raising/hr-ticket/leave-ticket/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.leaveTicket',
    'action.add'
  ]),
  leaveTicketEdit: getPath('/ticket-raising/hr-ticket/leave-ticket/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.leaveTicket',
    'action.edit'
  ]),
  leaveTicketSub: getPath('/s/hr-ticket/leave-ticket', [
    'v2.sidebar.home',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.leaveTicket'
  ]),
  myLeaveTicketSub: getPath('/s/hr-ticket/leave-ticket/my-ticket', [
    'v2.sidebar.home',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.leaveTicket',
    'Phiếu của tôi'
  ]),
  leaveTicketAddSub: getPath('/s/hr-ticket/leave-ticket/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.leaveTicket',
    'action.add'
  ]),
  leaveTicketEditSub: getPath('/s/hr-ticket/leave-ticket/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.leaveTicket',
    'action.edit'
  ]),
  myLeavePackage: getPath('/ticket-raising/hr-ticket/leave-ticket/my-package', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.leaveTicket',
    'Package của tôi'
  ]),
  leavePackageApproval: getPath('/ticket-raising/hr-ticket/leave-ticket/approval-package', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.leaveTicket',
    'Phê duyệt Package'
  ]),
  leavePackageAdd: getPath('/ticket-raising/hr-ticket/leave-ticket/add-package', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.leavePackage',
    'action.add'
  ]),
  // Resignation Ticket
  resignationTicket: getPath('/ticket-raising/hr-ticket/resignation-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.resignationTicket'
  ]),
  myResignationTicket: getPath('/ticket-raising/hr-ticket/resignation-ticket/my-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.resignationTicket',
    'Phiếu của tôi'
  ]),
  resignationTicketApproval: getPath('/ticket-raising/hr-ticket/resignation-ticket/approval', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.resignationTicket',
    'v2.sidebar.approval'
  ]),
  resignationTicketAdd: getPath('/ticket-raising/hr-ticket/resignation-ticket/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.resignationTicket',
    'action.add'
  ]),
  resignationTicketEdit: getPath('/ticket-raising/hr-ticket/resignation-ticket/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.resignationTicket',
    'action.edit'
  ]),
  resignationTicketSub: getPath('/s/hr-ticket/resignation-ticket', [
    'v2.sidebar.home',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.resignationTicket'
  ]),
  myResignationTicketSub: getPath('/s/hr-ticket/resignation-ticket/my-ticket', [
    'v2.sidebar.home',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.resignationTicket',
    'Phiếu của tôi'
  ]),
  resignationTicketAddSub: getPath('/s/hr-ticket/resignation-ticket/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.resignationTicket',
    'action.add'
  ]),
  resignationTicketEditSub: getPath('/s/hr-ticket/resignation-ticket/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.resignationTicket',
    'action.edit'
  ]),

  // Expense Tracking Request Ticket
  expenseTrackingRequestTicket: getPath('/ticket-raising/hr-ticket/expense-tracking-request-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.expenseTrackingRequestTicket'
  ]),
  myExpenseTrackingRequestTicket: getPath('/ticket-raising/hr-ticket/expense-tracking-request-ticket/my-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.expenseTrackingRequestTicket',
    'Phiếu của tôi'
  ]),
  expenseTrackingRequestTicketApproval: getPath('/ticket-raising/hr-ticket/expense-tracking-request-ticket/approval', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.expenseTrackingRequestTicket',
    'v2.sidebar.approval'
  ]),
  expenseTrackingRequestTicketAdd: getPath('/ticket-raising/hr-ticket/expense-tracking-request-ticket/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.expenseTrackingRequestTicket',
    'action.add'
  ]),
  expenseTrackingRequestTicketEdit: getPath('/ticket-raising/hr-ticket/expense-tracking-request-ticket/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.expenseTrackingRequestTicket',
    'action.edit'
  ]),

  // Overtime Ticket
  overtimeTicket: getPath('/ticket-raising/hr-ticket/overtime-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.overtimeTicket'
  ]),
  myOvertimeTicket: getPath('/ticket-raising/hr-ticket/overtime-ticket/my-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.overtimeTicket',
    'Phiếu của tôi'
  ]),
  overtimeTicketApproval: getPath('/ticket-raising/hr-ticket/overtime-ticket/approval', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.overtimeTicket',
    'v2.sidebar.approval'
  ]),
  overtimeTicketAdd: getPath('/ticket-raising/hr-ticket/overtime-ticket/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.overtimeTicket',
    'action.add'
  ]),
  overtimeTicketEdit: getPath('/ticket-raising/hr-ticket/overtime-ticket/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.overtimeTicket',
    'action.edit'
  ]),
  overtimeTicketConfirm: getPath('/ticket-raising/hr-ticket/overtime-ticket/confirm', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.overtimeTicket',
    'action.confirm'
  ]),
  overtimeTicketSupervisorConfirm: getPath('/ticket-raising/hr-ticket/overtime-ticket/supervisor-confirm', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.overtimeTicket',
    'action.supervisorConfirm'
  ]),

  // Business Trip Ticket
  businessTripTicket: getPath('/ticket-raising/hr-ticket/business-trip-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.businessTripTicket'
  ]),
  myBusinessTripTicket: getPath('/ticket-raising/hr-ticket/business-trip-ticket/my-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.businessTripTicket',
    'Phiếu của tôi'
  ]),
  businessTripTicketApproval: getPath('/ticket-raising/hr-ticket/business-trip-ticket/approval', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.businessTripTicket',
    'Phê duyệt'
  ]),
  businessTripTicketAdd: getPath('/ticket-raising/hr-ticket/business-trip-ticket/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.businessTripTicket',
    'action.add'
  ]),
  businessTripTicketEdit: getPath('/ticket-raising/hr-ticket/business-trip-ticket/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.businessTripTicket',
    'action.edit'
  ]),

  // Purchase Request Ticket
  purchaseRequestTicket: getPath('/ticket-raising/hr-ticket/purchase-request-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.purchaseRequestTicket'
  ]),
  myPurchaseRequestTicket: getPath('/ticket-raising/hr-ticket/purchase-request-ticket/my-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.purchaseRequestTicket',
    'Phiếu của tôi'
  ]),
  purchaseRequestTicketApproval: getPath('/ticket-raising/hr-ticket/purchase-request-ticket/approval', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.purchaseRequestTicket',
    'Phê duyệt'
  ]),
  purchaseRequestTicketAdd: getPath('/ticket-raising/hr-ticket/purchase-request-ticket/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.purchaseRequestTicket',
    'action.add'
  ]),
  purchaseRequestTicketEdit: getPath('/ticket-raising/hr-ticket/purchase-request-ticket/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.purchaseRequestTicket',
    'action.edit'
  ]),

  // Transportation Ticket
  transportationTicket: getPath('/ticket-raising/hr-ticket/transportation-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.transportationTicket'
  ]),
  myTransportationTicket: getPath('/ticket-raising/hr-ticket/transportation-ticket/my-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.transportationTicket',
    'Phiếu của tôi'
  ]),
  transportationTicketApproval: getPath('/ticket-raising/hr-ticket/transportation-ticket/approval', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.transportationTicket',
    'Phê duyệt'
  ]),
  transportationTicketConfirm: getPath('/ticket-raising/hr-ticket/transportation-ticket/confirm', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.transportationTicket',
    'Xác nhận'
  ]),
  transportationTicketHandle: getPath('/ticket-raising/hr-ticket/transportation-ticket/handle', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.transportationTicket',
    'Phiếu của tôi xử lý'
  ]),
  transportationTicketAdd: getPath('/ticket-raising/hr-ticket/transportation-ticket/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.transportationTicket',
    'action.add'
  ]),
  transportationTicketEdit: getPath('/ticket-raising/hr-ticket/transportation-ticket/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.transportationTicket',
    'action.edit'
  ]),

  // Equipment Supply Request Ticket
  equipmentSupplyRequestTicket: getPath('/ticket-raising/hr-ticket/equipment-supply-request-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.equipmentSupplyRequestTicket'
  ]),
  myEquipmentSupplyRequestTicket: getPath('/ticket-raising/hr-ticket/equipment-supply-request-ticket/my-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.equipmentSupplyRequestTicket',
    'Phiếu của tôi'
  ]),
  equipmentSupplyRequestTicketApproval: getPath('/ticket-raising/hr-ticket/equipment-supply-request-ticket/approval', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.equipmentSupplyRequestTicket',
    'Phê duyệt'
  ]),
  equipmentSupplyRequestTicketAdd: getPath('/ticket-raising/hr-ticket/equipment-supply-request-ticket/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.equipmentSupplyRequestTicket',
    'action.add'
  ]),
  equipmentSupplyRequestTicketEdit: getPath('/ticket-raising/hr-ticket/equipment-supply-request-ticket/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.equipmentSupplyRequestTicket',
    'action.edit'
  ]),

  // Additional Working Time Ticket
  additionalWorkingTimeTicket: getPath('/ticket-raising/hr-ticket/additional-working-time-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.additionalWorkingTimeTicket'
  ]),
  myAdditionalWorkingTimeTicket: getPath('/ticket-raising/hr-ticket/additional-working-time-ticket/my-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.additionalWorkingTimeTicket',
    'Phiếu của tôi'
  ]),
  additionalWorkingTimeTicketApproval: getPath('/ticket-raising/hr-ticket/additional-working-time-ticket/approval', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.additionalWorkingTimeTicket',
    'Phê duyệt'
  ]),
  additionalWorkingTimeTicketAdd: getPath('/ticket-raising/hr-ticket/additional-working-time-ticket/add', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.additionalWorkingTimeTicket',
    'action.add'
  ]),
  additionalWorkingTimeTicketEdit: getPath('/ticket-raising/hr-ticket/additional-working-time-ticket/edit', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'v2.sidebar.hrTicket.additionalWorkingTimeTicket',
    'action.edit'
  ]),
  // myAdditionalWorkingTimePackage: getPath('/ticket-raising/hr-ticket/additional-working-time-ticket/my-package', [
  //   'v2.sidebar.home',
  //   'v2.helpdesk.index',
  //   'v2.sidebar.hrTicket.index',
  //   'v2.sidebar.hrTicket.additionalWorkingTimeTicket',
  //   'Package của tôi'
  // ]),
  // additionalWorkingTimePackageApproval: getPath(
  //   '/ticket-raising/hr-ticket/additional-working-time-ticket/approval-package',
  //   [
  //     'v2.sidebar.home',
  //     'v2.helpdesk.index',
  //     'v2.sidebar.hrTicket.index',
  //     'v2.sidebar.hrTicket.additionalWorkingTimeTicket',
  //     'Phê duyệt Package'
  //   ]
  // ),
  // additionalWorkingTimePackageAdd: getPath('/ticket-raising/hr-ticket/additional-working-time-package/add', [
  //   'v2.sidebar.home',
  //   'v2.helpdesk.index',
  //   'v2.sidebar.hrTicket.index',
  //   'v2.sidebar.hrTicket.additionalWorkingTimePackage',
  //   'action.add'
  // ]),
  // additionalWorkingTimePackageEdit: getPath('/ticket-raising/hr-ticket/additional-working-time-package/edit', [
  //   'v2.sidebar.home',
  //   'v2.helpdesk.index',
  //   'v2.sidebar.hrTicket.index',
  //   'v2.sidebar.hrTicket.additionalWorkingTimePackage',
  //   'action.edit'
  // ]),

  // Salary Ticket
  salaryTicket: getPath('/ticket-raising/hr-ticket/salary-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrTicket.index',
    'Phiếu lương'
  ]),
  salaryTicketSub: getPath('/s/hr-ticket/salary-ticket', ['v2.sidebar.home', 'Phiếu lương']),

  // HR Confirm
  hrConfirm: getPath('/ticket-raising/hr-confirm', ['v2.sidebar.home', 'v2.sidebar.hrConfirm.index']),
  hrConfirmLeaveTicket: getPath('/ticket-raising/hr-confirm/leave-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrConfirm.index',
    'v2.sidebar.hrConfirm.leaveTicket'
  ]),
  hrConfirmExpenseTrackingRequestTicket: getPath('/ticket-raising/hr-confirm/expense-tracking-request-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrConfirm.index',
    'v2.sidebar.hrConfirm.leaveTicket'
  ]),
  hrConfirmOvertimeTicket: getPath('/ticket-raising/hr-confirm/overtime-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrConfirm.index',
    'v2.sidebar.hrConfirm.overtimeTicket'
  ]),
  hrConfirmBusinessTripTicket: getPath('/ticket-raising/hr-confirm/business-trip-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrConfirm.index',
    'v2.sidebar.hrConfirm.businessTripTicket'
  ]),
  hrConfirmTransportationTicket: getPath('/ticket-raising/hr-confirm/transportation-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrConfirm.index',
    'v2.sidebar.hrConfirm.transportationTicket'
  ]),
  hrConfirmResignationTicket: getPath('/ticket-raising/hr-confirm/resignation-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrConfirm.index',
    'v2.sidebar.hrConfirm.resignationTicket'
  ]),
  hrConfirmAdditionalWorkingTimeTicket: getPath('/ticket-raising/hr-confirm/additional-working-time-ticket', [
    'v2.sidebar.home',
    'v2.helpdesk.index',
    'v2.sidebar.hrConfirm.index',
    'v2.sidebar.hrConfirm.additionalWorkingTimeTicket'
  ])
};
